import React from 'react';
import { t } from '../multi-language/multi-lang.service';
import { ARRYTH_KEYS_TO_TYPES } from '../consts';
function DetectionsLegends(_a) {
    var detections_data = _a.detections_data;
    var detectionsKeys = detections_data.detectionsKeys;
    var displayLegends = function () {
        //we do not display pr legends
        var filtered = detectionsKeys === null || detectionsKeys === void 0 ? void 0 : detectionsKeys.filter(function (d) { return d.detection_type !== 'pr'; });
        return (filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0;
    };
    if (!displayLegends())
        return React.createElement(React.Fragment, null);
    var getLegendText = function () {
        var detectionTypes = {};
        for (var _i = 0, detectionsKeys_1 = detectionsKeys; _i < detectionsKeys_1.length; _i++) {
            var d = detectionsKeys_1[_i];
            if (d.detection_type !== 'pr' && !detectionTypes[d.type]) {
                detectionTypes[d.type] = ARRYTH_KEYS_TO_TYPES[d.typeKey];
            }
        }
        return Object.keys(detectionTypes).map(function (d, i) {
            var text = t("arryth_report.cardio.hr_events.".concat(detectionTypes[d], ".name"));
            return React.createElement(React.Fragment, null,
                i > 0 && React.createElement("span", { className: 'px-2' }, "|"),
                React.createElement("span", { className: 'legend-key font-weight-bold pe-1' }, d),
                React.createElement("span", null, text));
        });
    };
    return (React.createElement("div", { className: 'detections-legends mx-7' },
        React.createElement("p", { className: 'detections-legends-text font-weight-normal' },
            React.createElement("span", { className: 'pe-1' },
                t('charts.detections.legend'),
                ":"),
            getLegendText())));
}
export default DetectionsLegends;
//# sourceMappingURL=detections-legends.js.map